import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';
import axios from 'axios';
import qs from 'qs';

import {Icon, message, Modal} from 'ant-design-vue';
import './antd-vue-components';

import pageHead from './components/top.vue';
import pageBottom from './components/bottom.vue';

import './assets/css/global.scss';
import './assets/fonts/iconfont.scss';

import loading from './js/loading';
import baseConfig from './js/config.js';
import app from './js/app.js';
import roleHelper from './js/roleHelper.js';
import basicRequest from './js/basicRequest.js';
import pageHelper from './js/pageHelper.js';

import VueClipboard from 'vue-clipboard2'; //剪切板
Vue.use(VueClipboard);

Vue.config.productionTip = false;

//这里写完了还需要在shims-tsx.d.ts重新配置一遍，否则不生效
Vue.prototype.$store = store;
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;

Vue.prototype.$loading = loading;
Vue.prototype.$baseConfig = baseConfig;
Vue.prototype.$app = app;
Vue.prototype.$roleHelper = roleHelper;
Vue.prototype.$basicRequest = basicRequest;
Vue.prototype.$pageHelper = pageHelper;

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: require('./assets/fonts/iconfont.js')
});

Vue.component('page-top', pageHead);
Vue.component('page-bottom', pageBottom);
Vue.component('c-font-icon', IconFont);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
